import { motion } from 'framer-motion';
import { Search, Shuffle } from 'lucide-react';
import { RefObject } from 'react';

interface SearchBarProps {
  searchQuery: string;
  onSearch: (query: string) => void;
  onRandom: () => void;
  showRandomButton?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
}

export const SearchBar = ({
  searchQuery,
  onSearch,
  onRandom,
  showRandomButton = true,
  inputRef
}: SearchBarProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="w-full max-w-4xl mx-auto px-6 -mt-8 relative z-10"
    >
      <div className="bg-white rounded-2xl shadow-2xl p-4 flex items-center gap-4 transition-all hover:shadow-3xl focus-within:shadow-3xl focus-within:scale-[1.01]">
        <Search className="text-slate-400 flex-shrink-0" size={24} />

        <input
          ref={inputRef}
          type="text"
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Cherchez un terme, un concept, une frustration..."
          className="flex-1 text-lg outline-none text-slate-800 placeholder-slate-400"
          autoComplete="off"
        />

        {showRandomButton && (
          <button
            onClick={onRandom}
            className="flex items-center gap-2 px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white rounded-xl font-medium transition-all hover:scale-105 active:scale-95"
            aria-label="Terme aléatoire"
          >
            <Shuffle size={18} />
            <span className="hidden sm:inline">Aléatoire</span>
          </button>
        )}
      </div>

      <p className="text-center text-sm text-slate-500 mt-2">
        <kbd className="px-2 py-1 bg-slate-100 rounded text-xs">Cmd</kbd> + <kbd className="px-2 py-1 bg-slate-100 rounded text-xs">K</kbd> pour rechercher
      </p>
    </motion.div>
  );
};
